/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

export const normalizeFontFamily = (fontFamily = '') => fontFamily
    .replace(/^font-family\s*:\s*/i, '')
    .replace(/;$/, '')
    .trim();

const buildFontFamilyDeclaration = (fontFamily = '') => {
    const normalized = fontFamily.trim();

    if (!normalized) {
        return '';
    }

    if (/^font-family\s*:/i.test(normalized)) {
        return normalized.replace(/;$/, '');
    }

    return `font-family: ${normalized}`;
};

const buildFontLinkElement = (fontTag = '', index = 0) => {
    const hrefMatch = fontTag.match(/href=["']([^"']+)["']/i);

    if (!hrefMatch?.[1]) {
        return null;
    }

    return <link key={`${hrefMatch[1]}-${index}`} rel="stylesheet" href={hrefMatch[1]} />;
};

export const buildTypographyTheme = (cmsThemeData = {}, baseTypography = {}) => {
    const typography = {
        ...baseTypography,
        cms: [],
    };
    const linkImports = [];

    if (cmsThemeData?.typography) {
        cmsThemeData.typography.forEach((font) => {
            if (font.font_reference) {
                typography.cms.push({ ...font.font_reference });
            } else if (font.webfont_link?.font_tag) {
                linkImports.push(font.webfont_link.font_tag);
            } else {
                typography.cms.push({ ...font });
            }
        });
    }

    if (cmsThemeData?.global_font_family && !baseTypography?.fontFamily) {
        typography.fontFamily = normalizeFontFamily(cmsThemeData.global_font_family);
    }

    const stackArr = [];
    if (cmsThemeData?.global_font_family) {
        stackArr.push(`body {${buildFontFamilyDeclaration(cmsThemeData.global_font_family)}; font-size: ${cmsThemeData.baseline_font_size}px}`);
    }

    if (typography.cms.length) {
        typography.cms.forEach((font) => {
            if (font?.webfont?.length) {
                const primaryUrl = font.webfont[0]?.url;
                const fallbackUrl = font.webfont[1]?.url || primaryUrl;

                if (primaryUrl) {
                    stackArr.push(`@font-face {font-family: ${font.font_name}; src: url(${primaryUrl}), url(${fallbackUrl}); font-display: swap;}`);
                }
            }
        });
    }

    if (stackArr.length) {
        typography.styleblock = (
            <>
                <style data-type="font-stack">{stackArr.join('\n')}</style>
                {linkImports.map((fontTag, index) => buildFontLinkElement(fontTag, index))}
            </>
        );
    } else if (linkImports.length) {
        typography.styleblock = (
            <>
                {linkImports.map((fontTag, index) => buildFontLinkElement(fontTag, index))}
            </>
        );
    }

    return typography;
};
